

import { ApolloQueryResult } from '@apollo/client';
import { IProps } from '@components/messages/types';
import React, { useEffect, useState } from 'react';
import { ITableActions } from 'apps/things/app/item/context/ItemProvider';
// import {
//   GetAllAgentsForSpecificDistributorStaff,
//   GetAllAgentsForSpecificDistributorStaffVariables,
//   GetAllDistributorStaffsForSpecificDistributor_getAllDistributorStaffsForSpecificDistributor_page_edges
// } from "../types/GetAllAgentsForSpecificDistributorStaff";
import {
GetAllDistributorStaffsForSpecificDistributor,
GetAllDistributorStaffsForSpecificDistributorVariables,
GetAllDistributorStaffsForSpecificDistributor_getAllDistributorStaffsForSpecificDistributor_page_edges
} from "../types/GetAllDistributorStaffsForSpecificDistributor"

import { useLazyGetAllAgentsForSpecificDistributorStaffQuery } from '../queries';
import useOVSPagination from 'hooks/useOVSPagination';
import { funNumberAgr } from '@types';
export interface ICustomAgentContext {
  items:  GetAllDistributorStaffsForSpecificDistributor_getAllDistributorStaffsForSpecificDistributor_page_edges[];
  setItems: (item:  GetAllDistributorStaffsForSpecificDistributor_getAllDistributorStaffsForSpecificDistributor_page_edges[]) => void;
  loading: boolean;
  getItems: () => void;
  activeStage: number;
  setActiveStage: (stage: number) => void;
  tableActions: ITableActions[];
  refetchItems:
    | ((
        variables?: Partial<GetAllDistributorStaffsForSpecificDistributorVariables> | undefined
      ) => Promise<ApolloQueryResult<GetAllDistributorStaffsForSpecificDistributor>>)
    | undefined;
    setPageLimit: funNumberAgr;
    goTo: (nextPrev: boolean) => void;
    paging: any;
}

export const CustomDistributorStaffContext = React.createContext<ICustomAgentContext>(
  {} as ICustomAgentContext
);

const ThingBrokerProvider: React.FC<IProps> = ({ children }) => {
  const [activeStage, setActiveStage] = useState(0);
  const [item, setItem] = React.useState(
    {} as  GetAllDistributorStaffsForSpecificDistributor_getAllDistributorStaffsForSpecificDistributor_page_edges
  );
  const [items, setItems] = React.useState< GetAllDistributorStaffsForSpecificDistributor_getAllDistributorStaffsForSpecificDistributor_page_edges[]>(
    []
  );
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  /// hooks
  const {
    endCursorStack,
    initPagAction,
    setPaging,
    paging,
    setPageListLimit,
    pageListLimit
  } = useOVSPagination();


  const [
    getItems,
    { refetch: refetchItems, data, loading, fetchMore },
  ] = useLazyGetAllAgentsForSpecificDistributorStaffQuery({
    first: pageListLimit,
  });

  useEffect(() => {
    setItems(data?.getAllDistributorStaffsForSpecificDistributor?.page?.edges || []);
    setPaging({
      ...data?.getAllDistributorStaffsForSpecificDistributor?.pageData,
      ...data?.getAllDistributorStaffsForSpecificDistributor?.page?.pageInfo,
    }); // eslint-disable-next-line
  }, [data]);

  const goTo = async (next = true) => {
    if (isLoadingMore) return;

    let variables: GetAllDistributorStaffsForSpecificDistributorVariables = {
      first: pageListLimit,
      ...initPagAction(next),
    };

    if (fetchMore) {
      setIsLoadingMore(true);
      const _data = await fetchMore({
        variables,
        updateQuery: (previousResult, { fetchMoreResult }) => {
          setIsLoadingMore(false);
          if (!fetchMoreResult) {
            return previousResult;
          }
          return {
            ...fetchMoreResult,
          };
        },
      });

      setItems(_data?.data?.getAllDistributorStaffsForSpecificDistributor?.page?.edges || []);

      setPaging({
        ..._data?.data?.getAllDistributorStaffsForSpecificDistributor?.pageData,
        ..._data?.data?.getAllDistributorStaffsForSpecificDistributor?.page?.pageInfo,
        hasPreviousPage: endCursorStack.length > 0,
      });
    }
  };

  const setPageLimit = (limit: number) => {
    setPageListLimit(limit)
    setTimeout(() => {
      refetchItems && refetchItems()
    }, 100);

  }
  const value = React.useMemo(
    () => ({
      item,
      setItem,
      items,
      setItems,
      loading: loading,
      getItems: getItems,
      refetchItems,
      tableActions: [],
      activeStage,
      setActiveStage,
      setPageLimit,
      goTo,
      paging
    }), // eslint-disable-next-line
    [items, loading]
  );

  return (
    <CustomDistributorStaffContext.Provider value={value}>{children}</CustomDistributorStaffContext.Provider>
  );
};

export default ThingBrokerProvider;
